// extracted by mini-css-extract-plugin
export default {"backMain":"Home_backMain__2Cy-4","title":"Home_title__L087v","tabs":"Home_tabs__bcORA","listRoutes":"Home_listRoutes__-1XuE"};